<!--
 * @Author: your name
 * @Date: 2021-01-19 19:01:14
 * @LastEditTime: 2021-01-27 15:55:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\jnApp\default.vue
-->
<template>
    <div class="presidentReport">
        <van-nav-bar
            title="数据快报"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="container">
            <div class="banner"></div>
            <div class="menus">
                <div
                    class="menu-item"
                    v-for="(item,index) in menusData"
                    :key="index"
                    @click="to(item.path)"
                >
                    <div class="icon">
                        <img :src="item.icon">
                    </div>
                    <div class="tit">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import imgUrl2 from './../../../assets/images/jnApp/bulletin_icon_1.png';
import imgUrl3 from './../../../assets/images/jnApp/bulletin_icon_5.png';
import imgUrl6 from './../../../assets/images/jnApp/bulletin_icon_2.png';
import imgUrl7 from './../../../assets/images/jnApp/bulletin_icon_3.png';
import imgUrl8 from './../../../assets/images/jnApp/bulletin_icon_4.png';
export default {
    data() {
        return {
            menusData: [
                { name: '销售快报', path: 'dataSalesReport', icon: imgUrl2 },
                { name: '生产快报', path: 'dataProductionReport', icon: imgUrl6 },
                { name: '配比消耗', path: 'dataMatchingConsumption', icon: imgUrl7 },
                { name: '客户应收', path: 'dataCustomerReceive', icon: imgUrl3 },
                { name: '供应商应付', path: 'dataSupplierPayable', icon: imgUrl8 },
            ],
        };
    },
    mounted() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path });
        },
    },
};
</script>

<style lang="stylus">
    .presidentReport
        .container
            .banner
                height 184rpx
                background url('./../../../assets/images/homeLd/banner.png') no-repeat
                background-size 100% 100%
            .menus
                padding 20rpx 0 0 20rpx
                overflow hidden
                .menu-item
                    float left
                    width 70rpx
                    height 70rpx
                    background url('./../../../assets/images/jnApp/bg.png') no-repeat
                    background-size 100% 100%
                    text-align center
                    margin 0 18rpx 20rpx 0
                    .icon
                        padding-top 10rpx
                    img
                        width 30rpx
                        height 30rpx
                    .tit
                        font-size 12rpx
</style>
